module.exports = __webpack_public_path__ + "static/img/concaveLevel_Depth.4179262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/curvedSurface/concaveLevel_Depth.png
// module id = DZuc
// module chunks = 3